export default __webpack_public_path__ + "294500093b60c4088603e1ce4fd3e7ae.png";